// Centralized API configuration
const DEFAULT_API_URL =
  process.env.NODE_ENV === 'production'
    ? 'https://api.intelliklix.com'
    : 'http://localhost:5000';

export const API_URL = process.env.REACT_APP_API_URL || DEFAULT_API_URL;

// Helper function for API calls
export const apiCall = async (endpoint, options = {}) => {
  const url = `${API_URL}${endpoint}`;
  const response = await fetch(url, options);
  return response;
};

// Helper for GET requests
export const apiGet = async (endpoint) => {
  return apiCall(endpoint, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' }
  });
};

// Helper for POST requests
export const apiPost = async (endpoint, data) => {
  return apiCall(endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  });
};

// Helper for PUT requests
export const apiPut = async (endpoint, data) => {
  return apiCall(endpoint, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  });
};

// Helper for DELETE requests
export const apiDelete = async (endpoint) => {
  return apiCall(endpoint, {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' }
  });
};

export default API_URL;
